
import Stars from "./5-stars.png";
import AllCharacters from "./all-characters.png";
import AllCharacters2 from "./all-characters2.png";
import AllCharacters33 from "./all-characters33.png";
import BusinessStandardLogo from "./business-standard.webp";
import CancelIcon from "./cancel_icon.png";
import Caption from "./caption.png";
import Caret from "./caret.png";
import ForbesLogo from "./forbes-india.png";
import NavbharatTimesLogo from "./navbharat_times.png";
import News18Logo from "./news18.png";
import Parent1 from "./parent1.png";
import Parent2 from "./parent2.png";
import Parent3 from "./parent3.png";
import Parent4 from "./parent4.png";
import Parent5 from "./parent5.png";
import PlayStoreLogo from "./play-store.png";
import PurpleRetangle from "./purple-rectangle.png";
import PurpleBottomStrip from "./purple_bottom_strip.png";
import PurpleCurvedBG from "./purple_curved_bg.png";
import AppRating from "./rating.png";
import RedCaption from "./red_caption.png";
import StarEmpty from "./star-empty.png";
import StarFilled from "./star-fill.png";
import Star from "./star.png";
import ThePrintLogo from "./the-print.png";
import Tick from "./tick.png";
import TimesOfIndiaLogo from "./times_of_india.png";
import TopBackgroundPurple from "./top-bg-purple.png";
import TopBackgroundPurple2 from "./top-bg-purple2.png";
import TopBackgroundPurple3 from "./top-bg-purple3.png";
import TopBackground from "./top-bg.png";
import TopPurple from "./top-purple.png";
import TopImage from "./top_image.png";
import WhatsAppLogo from "./whatsapp.png";
import YellowRectangle from "./yellow-rectangle.png";
import YellowCurvedBG from "./yellow_curved_bg.png";
import YellowTopCurvedStrip from "./yellow_top_curved_strip.png";
import YoutubeIcon from "./youtube_icon.png";
import YoutubeIcon2 from "./youtube_icon2.png";
import BottomImage from "./bottom_image.png";
import Thumbnail from "./thumbnail.png";
import PlayButton from "./play_button.png";

const HomeImages = {
  Parent1,
  Parent2,
  Parent3,
  Parent4,
  Parent5,
  StarFilled,
  StarEmpty,
  BusinessStandardLogo,
  ThePrintLogo,
  ForbesLogo,
  TimesOfIndiaLogo,
  NavbharatTimesLogo,
  News18Logo,
  TopBackground,
  TopBackgroundPurple,
  AllCharacters,
  Star,
  AppRating,
  PlayStoreLogo,
  Tick,
  Caret,
  Caption,
  RedCaption,
  YellowCurvedBG,
  PurpleCurvedBG,
  WhatsAppLogo,
  TopImage,
  AllCharacters2,
  TopPurple,
  Stars,
  YellowRectangle,
  PurpleRetangle,
  AllCharacters33,
  TopBackgroundPurple2,
  TopBackgroundPurple3,
  YellowTopCurvedStrip,
  PurpleBottomStrip,
  YoutubeIcon,
  YoutubeIcon2,
  CancelIcon,
  BottomImage,
  Thumbnail,
  PlayButton
};

export default HomeImages;
